import { Loader } from '@fluentui/react-northstar';
import * as React from 'react';
import { v4 as uuid } from 'uuid';
import { ISessionContextProps, ISessionContextProviderDataProps, ISessionContextProviderState } from './SessionContext.types';

/**
 * Session ID is a constant that we read from the teamsContext object.
 *
 * This allows us to correlate the entire user's session in our logs, from where
 * they started in Teams, all through CEH.
 *
 * We pass this to the CEH MT on the x-ms-sessionid header, and add it as a property
 * to all Aria logs inside of Logger.ts.
 */
export let SESSION_ID = uuid();
export let RING_ID: null | string = null;

export const SessionContext = React.createContext<ISessionContextProps>({
  sessionId: SESSION_ID,
  ringId: RING_ID
});

export class SessionContextProvider extends React.Component<
  ISessionContextProviderDataProps,
  ISessionContextProviderState
> {
  public render(): JSX.Element {
    const { teamsContext } = this.props;
    if (!teamsContext || !teamsContext.sessionId || !teamsContext.ringId) {
      return <Loader />;
    }
    const contextValue: ISessionContextProps = {
      sessionId: teamsContext.sessionId,
      ringId: teamsContext.ringId
    };
    SESSION_ID = teamsContext.sessionId;
    RING_ID = teamsContext.ringId;
    return (
      <SessionContext.Provider value={contextValue}>
        {this.props.children}
      </SessionContext.Provider>
    );
  }
}
